<template>
  <el-select v-model="id" :size="size" :clearable="clearable" :disabled="disabled" :multiple="multiple" placeholder="请选择" :remote-method="remoteMethod" :loading="loading" @change="selectChange">
    <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.type">
      <span>{{ item.name }}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: "",
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "small",
    },
    isChildren: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      list: [],
      id: "",
      loading: false,
    }
  },
  created() {
    this.id = this.value;
  },
  mounted() {
    this.remoteMethod(this.value);
  },
  watch: {
    value: function (newValue) {
      this.id = newValue;
    }
  },
  methods: {
    remoteMethod(query) {
      this.list = [
        { id: "1", name: "单选", type: 1 },
        { id: "2", name: "多选", type: 2 },
        { id: "3", name: "判断", type: 3 },
        { id: "4", name: "排序", type: 4 },
        { id: "5", name: "填空", type: 5 },
        { id: "6", name: "阅读", type: 6 },
        { id: "7", name: "简答", type: 7 },
      ]
      if (this.isChildren) {
        this.list.splice(5, 1);
      }
    },
    selectChange(val) {
      this.$emit('input', val);
      if (!this.multiple) {
        let obj = this.list.find(item => val == item.type);
        this.$emit('change', obj);
      } else {
        let list = this.list.filter(item => val.indexOf(item.type) >= 0);
        this.$emit('change', list);
      }
    },
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/QuestionTypes.vue